export function GetProductNotificationConfig () {
  if (window.productNotificationConfig) {
    return {
      urlAdd: window.productNotificationConfig.urlAdd,
      urlCheck: window.productNotificationConfig.urlCheck,
      hasNotification: window.productNotificationConfig.hasNotification,
      testABShowMessage: window.productNotificationConfig.testABShowMessage
    }
  }

  return {}
}



// WEBPACK FOOTER //
// ./src/config/productNotificationConfig.js